import isEmpty from 'lodash/isEmpty';
import { fireStore } from '../firebase';

export const getDocs = async ({ filter }) => {
  let docRef = fireStore.collection('logs');
  
  if (filter) {
    if (!isEmpty(filter.type)) {
      docRef = docRef.where('type', '==', filter.type);
    }

    if (!isEmpty(filter.user)) {
      docRef = docRef.where('user', '==', filter.user);
    }
  }
  
  docRef = docRef.orderBy('time', 'desc').limit(3);
  
  return await docRef.get()
  .then((documentSnapshots) => {
    return documentSnapshots.docs;
  })
  .catch(error => { console.log(error); return error })
}

export const addDoc = async ({data}) => {
  return await fireStore.collection('logs').add(data);
}
